// @Vendors
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// @State
import { selectUserLogged } from '../../../state/auth/auth.selectors';
import { doLogout } from '../../../state/auth/auth.actions';
// import { selectServerErrors, selectStatusError } from 'state/app/app.selectors';
// import { clearServerErrors } from 'state/app/app.actions';

// @Components
import TopNavBar from '../../../components/nav/TopNavBar';
import Nav from '../../../components/nav/Nav';
import {getAuthorizationToken, getSessionId} from "../../../utils/auth";

class App extends Component {
  state = {
		navOpen: true
	}

	handleButtonNav = e => {
		const { navOpen } = this.state;
		this.setState({ navOpen: !navOpen })
		e.preventDefault();
		e.stopPropagation();
  }

  handleLinkClick = rol => {
    const {userLogged} = this.props;
    console.log("Esto es user Loged", userLogged);
      switch (rol.servicioHooliCod) {
          case 'HGATE':
              window.location = `https://gate.hooli.la?session=${getSessionId()}&token=${getAuthorizationToken()}&merchantId=${rol.merchantId}&latitud=${userLogged.latitud}&longitud=${userLogged.longituf}`;
              break;
          case 'AAD':
              window.location = `https://administracion.hooli.la?session=${getSessionId()}&token=${getAuthorizationToken()}&latitud=${userLogged.latitud}&longitud=${userLogged.longituf}`;
              break;
          case 'ASE':
              window.location = `https://seguros.hooli.la?session=${getSessionId()}&token=${getAuthorizationToken()}&latitud=${userLogged.latitud}&longitud=${userLogged.longituf}`;
              break;
          case 'AUS':
              window.location = `https://usuarios.hooli.la?session=${getSessionId()}&token=${getAuthorizationToken()}&latitud=${userLogged.latitud}&longitud=${userLogged.longituf}`;
              break;
          case 'ACO':
              window.location = `https://compliance.hooli.la?session=${getSessionId()}&token=${getAuthorizationToken()}&latitud=${userLogged.latitud}&longitud=${userLogged.longituf}`;
              break;
           case 'ABC' :
             window.location = `https://comerciosbo.hooli.la?session=${getSessionId()}&token=${getAuthorizationToken()}&latitud=${userLogged.latitud}&longitud=${userLogged.longitud}`;
           break;
          default:
              break;
      }
  }

  render() {
    const { children, userLogged, doLogout } = this.props;

		const { navOpen } = this.state;

    return (
      <div id='temp_backoffice' className={navOpen ? '' : 'collapse'}>
        <section id='temp_nav_bar'>
          <TopNavBar
            name={userLogged.usuarioNombres}
            onLogout={doLogout}
            pic='user/pic_backuser@2x.png'
            rol='BackUser'
            surname={userLogged.usuarioApellidos}
          />
          <Nav navOpen={navOpen} actionButtonNav={this.handleButtonNav} onLinkClick={this.handleLinkClick} roles={userLogged.roles} />
        </section>
        <section id='temp_body'>
          {children}
        </section>
    </div>
    );
  }
}

const mapStateToProps = state => ({
  // serverErrors: selectServerErrors(state),
  // statusError: selectStatusError(state),
  userLogged: selectUserLogged(state)
});

const actions = {
  // clearServerErrors,
  doLogout
};

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(App)
);



// WEBPACK FOOTER //
// ./src/pages/App/Templates/PageTemplate.js